import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { AppContext, IAppContext } from "../../AppContext";

import { errorHandler } from "../../library/errorHandler";
import { clientCoveragesErrorLabel } from "./FinanceTab/FinanceForm/requestedLinesHelpers";

type Props = {
  errors: any;
  configVehicle: any[];
  isSubmitting: boolean;
};

const VehicleFormErrors = ({ errors, configVehicle, isSubmitting }: Props) => {
  const { t } = useTranslation();

  const appContext = useContext<IAppContext>(AppContext);
  useEffect(() => {
    if (isSubmitting) {
      appContext.filterDuplicates(errors);

      //show error message only on submit (formik is set to validate on blur and change)
      Object.keys(errors).forEach((error) => {
        // the client's coverage request parts (coverage dates, MTPL limit,
        // hull deductible) have errors of their own, but no vehicle field
        const label =
          clientCoveragesErrorLabel(error, t) ??
          t(`bfm.vehicleForm.${error}.label`);
        errorHandler({
          value: `${label}: ${errors[error]}`,
          type: "error",
          label,
          fieldName:
            configVehicle.find((item) => item.name === error)?.name ?? error,
          errors,
        });
      });
    }
  }, [errors, isSubmitting]);

  return null;
};

export default VehicleFormErrors;
